export function SET_ACTIVITIES({ commit }, [activities]) {
	commit('SAVE_ACTIVITIES', [activities])
}

export function SET_ACTIVITIES_MENU({ commit }, [activities_menu]) {
	commit('SAVE_ACTIVITIES_MENU', [activities_menu])
}

export function SET_ACTIVITIES_MENU_LOADING({ commit }, [activities_menu, loading]) {
	commit('SAVE_ACTIVITIES_MENU_LOADING', [activities_menu, loading])
}

export function SET_ACTIVITY({ commit }, [hierarchy_order, id]) {
	commit('SAVE_ACTIVITY', [hierarchy_order, id])
}

export function SET_ACTIVITY_DATA({ commit }, [activity, newData]) {
	commit('SAVE_ACTIVITY_DATA', [{ ...activity, ...newData }])
}
